import { render, staticRenderFns } from "./ImportRbuSectionTemplateWarningDialog.vue?vue&type=template&id=6b4cffa5"
import script from "./ImportRbuSectionTemplateWarningDialog.vue?vue&type=script&lang=js"
export * from "./ImportRbuSectionTemplateWarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports